import { BenchmarkParameter } from "../Models/BenchmarkParameter";
import * as ko from "knockout";
import { Variety } from "../Models/Variety";
import { UrlParameters } from "../Models/Benchmark/UrlParameters";
import { YieldCleanedMaterialReport } from "../Models/Benchmark/YieldCleanedMaterialReport";
import { YieldNormalQualityReport } from "../Models/Benchmark/YieldNormalQualityReport";
import { YieldPaymentReport } from "../Models/Benchmark/YieldPaymentReport";
import { CleaningWasteReport } from "../Models/Benchmark/CleaningWasteReport";
import { CleaningPurityReport } from "../Models/Benchmark/CleaningPurityReport";
import { CleaningGerminationReport } from "../Models/Benchmark/CleaningGerminationReport";
import { BenchmarkApi } from "../apis/BenchmarkApi";
import "footable-npm";
import * as Highcharts from 'highcharts';


export class BenchmarkViewModel {
    benchmarkApi: BenchmarkApi;

    parameters = ko.observableArray<BenchmarkParameter>();
    selectedParameter = ko.observable(BenchmarkParameter);
    selectedVarieties = ko.observableArray<Variety>();
    selectedAreaRange = ko.observable<string>();
    yieldSelected = ko.observable(true);
    cleaningSelected = ko.observable(false);
    benchmarkType = ko.observable<string>("yield");
    reportType = ko.observable<string>("YieldCleanedMaterial");
    areaSelected = ko.observable(true);
    postcodeSelected = ko.observable(false);
    areaType = ko.observable<string>("ByArea");
    excludeBornholm = ko.observable(true);
    postcodeBegin = ko.observable<string>("7551");
    postcodeEnd = ko.observable<string>("9999");

    showYieldCleanedMaterial = ko.observable(false);
    showYieldNormalQuality = ko.observable(false);
    showYieldPayment = ko.observable(false);
    showCleaningWaste = ko.observable(false);
    showCleaningPurity = ko.observable(false);
    showCleaningGermination = ko.observable(false);
    showSpinner = ko.observable(false);
    showContent = ko.observable(false);
    disableYieldPayment = ko.observable(false);

    yieldCleanedMaterialReports = ko.observableArray<YieldCleanedMaterialReport>();
    yieldNormalQualityReports = ko.observableArray<YieldNormalQualityReport>();
    yieldPaymentReports = ko.observableArray<YieldPaymentReport>();
    cleaningWasteReports = ko.observableArray<CleaningWasteReport>();
    cleaningPurityReports = ko.observableArray<CleaningPurityReport>();
    cleaningGerminationReports = ko.observableArray<CleaningGerminationReport>();

    static benchmarkNotBeforeYieldPaymentText: string;
    static benchmarkAtLeastOneVarietyText: string;
    static benchmarkPostCodeBeginningLowerThanEndingText: string;


    benchmarkCharts = ko.observableArray<string>();

    constructor(benchmarkApi: BenchmarkApi) {
        this.benchmarkApi = benchmarkApi;
    }

    init(beforeYieldPaymentText: string, atLeastOneVarietyText: string, postCodeBeginningLowerThanEndingText: string) {
        BenchmarkViewModel.benchmarkNotBeforeYieldPaymentText = beforeYieldPaymentText;
        BenchmarkViewModel.benchmarkAtLeastOneVarietyText = atLeastOneVarietyText;
        BenchmarkViewModel.benchmarkPostCodeBeginningLowerThanEndingText = postCodeBeginningLowerThanEndingText;
    }

    submit(): void {
        let parameters = this.getUrlParameters();
        let reportType = this.reportType();

        this.benchmarkCharts([]);

        if (parameters.varietyIds == "") {
            alert(BenchmarkViewModel.benchmarkAtLeastOneVarietyText);
            return;
        }

        if (Number(this.postcodeBegin()) > Number(this.postcodeEnd())) {
            alert(BenchmarkViewModel.benchmarkPostCodeBeginningLowerThanEndingText);
            return;
        }

        this.showSpinner(true);
        this.showContent(false);

        this.showYieldCleanedMaterial(false);
        this.showYieldNormalQuality(false);
        this.showYieldPayment(false);
        this.showCleaningWaste(false);
        this.showCleaningPurity(false);
        this.showCleaningGermination(false);

        if (reportType == "YieldCleanedMaterial") {
            this.benchmarkApi.getYieldCleanedMaterialReport(parameters).then((res) => {
 
                try {
                    this.yieldCleanedMaterialReports(res);
                    this.showYieldCleanedMaterial(true);

                    for (var i = 0; i < res.length; i++) {
                        let data = new Array();

                        //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#CleanedMaterialHectareYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].CleanedMaterialHectareYearGrower]
                        });
                        //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#CleanedMaterialHectareRegion').text().trim(),
                            color: 'rgb(20,95,42)',
                            data: [res[i].CleanedMaterialHectareRegion]
                        });
                        //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#CleanedMaterialHectareCountry').text().trim(),
                            color: 'rgb(25,72,204)',
                            data: [res[i].CleanedMaterialHectareCountry]
                        });
                        //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#CleanedMaterialHectare5Year').text().trim(),
                            color: 'rgb(171,225,250)',
                            data: [res[i].CleanedMaterialHectare5Year]
                        });

                        if (data.length > 0)
                            this.createChart(i, res[i].VarietyName, "kg/ha", 0, data);
                    }

                    ($('#yieldCleanedMaterialTable') as any).footable();
                    this.showSpinner(false);

                    this.delay(1).then(() => {
                        this.showContent(true);
                    });
                }
                catch (ex) {
                    console.log(ex);
                }
            });
        } else {
            this.showYieldCleanedMaterial(false);
        }

        if (reportType == "YieldNormalQuality") {
            this.benchmarkApi.getYieldNormalQualityReport(parameters).then((res: YieldNormalQualityReport[]) => {
                console.log(res);
                try {
                    this.yieldNormalQualityReports(res);
                }
                catch (ex) {
                    console.log(ex);
                }
                
                this.showYieldNormalQuality(true);
                for (var i = 0; i < res.length; i++) {
                    let data = new Array();

                    //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#NormalQualityHectareYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].NormalQualityHectareYearGrower]
                        });

                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#NormalQualityHectareRegion').text().trim(),
                        color: 'rgb(20,95,42)',
                        data: [res[i].NormalQualityHectareRegion]
                    });
                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#NormalQualityHectareCountry').text().trim(),
                        color: 'rgb(25,72,204)',
                        data: [res[i].NormalQualityHectareCountry]
                    });
                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#NormalQualityHectare5Year').text().trim(),
                        color: 'rgb(171,225,250)',
                        data: [res[i].NormalQualityHectare5Year]
                    });

                    if (data.length > 0)
                        this.createChart(i, res[i].VarietyName, "kg/ha", 0, data);
                }
                ($('#yieldNormalQualityTable') as any).footable();
                this.showSpinner(false);

                this.delay(1).then(() => {
                    this.showContent(true);
                });
            });
        } else {
            this.showYieldNormalQuality(false);
        }

        if (reportType == "YieldPayment") {


            this.benchmarkApi.getYieldPaymentReport(parameters).then((res) => {
                try {
                    this.yieldPaymentReports(res);
                }
                catch (ex) {
                    console.log(ex);
                }
                this.showYieldPayment(true);
                for (var i = 0; i < res.length; i++) {
                    let data = new Array();

                    //Always push data, even if no data is present. GWDW-537
                        data.push({
                            name: $('#PaymentHectareYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].PaymentHectareYearGrower]
                        });

                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#PaymentHectareRegion').text().trim(),
                        color: 'rgb(20,95,42)',
                        data: [res[i].PaymentHectareRegion]
                    });

                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#PaymentHectareCountry').text().trim(),
                        color: 'rgb(25,72,204)',
                        data: [res[i].PaymentHectareCountry]
                        });

                    //Always push data, even if no data is present. GWDW-537
                    data.push({
                        name: $('#PaymentHectare5Year').text().trim(),
                        color: 'rgb(171,225,250)',
                        data: [res[i].PaymentHectare5Year]
                    });

                    if (data.length > 0)
                     this.createChart(i, res[i].VarietyName, "kr/ha", 0, data);
                }
                ($('#yieldPaymentTable') as any).footable();
                this.showSpinner(false);

                this.delay(1).then(() => {
                    this.showContent(true);
                });
            });
        } else {
            this.showYieldPayment(false);
        }

        if (reportType == "CleaningWaste") {
            this.benchmarkApi.getCleaningWasteReport(parameters).then((res) => {
                this.cleaningWasteReports(res);
                this.showCleaningWaste(true);
                for (var i = 0; i < res.length; i++) {
                    let data = new Array();

                        data.push({
                            name: $('#CleaningWastePercentYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].CleaningWastePercentYearGrower]
                    });

                        data.push({
                            name: $('#CleaningWastePercentRegion').text().trim(),
                            color: 'rgb(20,95,42)',
                            data: [res[i].CleaningWastePercentRegion]
                        });


                        data.push({
                            name: $('#CleaningWastePercentCountry').text().trim(),
                            color: 'rgb(25,72,204)',
                            data: [res[i].CleaningWastePercentCountry]
                        });


                        data.push({
                            name: $('#CleaningWastePercentSpecieGrowerYear').text().trim(),
                            color: 'rgb(171,225,250)',
                            data: [res[i].CleaningWastePercentSpecieGrowerYear]
                        });


                        data.push({
                            name: $('#CleaningWastePercent5Year').text().trim(),
                            color: 'rgb(77,77,77)',
                            data: [res[i].CleaningWastePercent5Year]
                        });

                    if (data.length > 0)
                        this.createChart(i, res[i].VarietyName, "%", 1, data);
                }
                ($('#cleaningWasteTable') as any).footable();
                this.showSpinner(false);

                this.delay(1).then(() => {
                    this.showContent(true);
                });
            });
        } else {
            this.showCleaningWaste(false);
        }

        if (reportType == "CleaningPurity") {
            this.benchmarkApi.getCleaningPurityReport(parameters).then((res) => {
                this.cleaningPurityReports(res);
                this.showCleaningPurity(true);
                for (var i = 0; i < res.length; i++) {
                    let data = new Array();

                        data.push({
                            name: $('#PurityPercentYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].PurityPercentYearGrower]
                        });

                        data.push({
                            name: $('#PurityPercentRegion').text().trim(),
                            color: 'rgb(20,95,42)',
                            data: [res[i].PurityPercentRegion]
                        });

                        data.push({
                            name: $('#PurityPercentCountry').text().trim(),
                            color: 'rgb(25,72,204)',
                            data: [res[i].PurityPercentCountry]
                        });

                        data.push({
                            name: $('#PurityPercentSpecieGrowerYear').text().trim(),
                            color: 'rgb(171,225,250)',
                            data: [res[i].PurityPercentSpecieGrowerYear]
                        });

                        data.push({
                            name: $('#PurityPercent5Year').text().trim(),
                            color: 'rgb(77,77,77)',
                            data: [res[i].PurityPercent5Year]
                        });

                    if (data.length > 0)
                        this.createChart(i, res[i].VarietyName, "%", 1, data);
                }
                ($('#cleaningPurityTable') as any).footable();
                this.showSpinner(false);

                this.delay(1).then(() => {
                    this.showContent(true);
                });
            });
        } else {
            this.showCleaningPurity(false);
        }

        if (reportType == "CleaningGermination") {
            this.benchmarkApi.getCleaningGerminationReport(parameters).then((res) => {
                this.cleaningGerminationReports(res);
                this.showCleaningGermination(true);
                for (var i = 0; i < res.length; i++) {
                    let data = new Array();

                        data.push({
                            name: $('#GerminationPercentYearGrower').text().trim(),
                            color: 'rgb(0,166,81)',
                            data: [res[i].GerminationPercentYearGrower]
                        });

                        data.push({
                            name: $('#GerminationPercentRegion').text().trim(),
                            color: 'rgb(20,95,42)',
                            data: [res[i].GerminationPercentRegion]
                        });

                        data.push({
                            name: $('#GerminationPercentCountry').text().trim(),
                            color: 'rgb(25,72,204)',
                            data: [res[i].GerminationPercentCountry]
                        });

                        data.push({
                            name: $('#GerminationPercentSpecieGroweYear').text().trim(),
                            color: 'rgb(171,225,250)',
                            data: [res[i].GerminationPercentSpecieGroweYear]
                        });

                    //if (res[i].GerminationPercentTotal != null)
                    //    data.push({
                    //        name: $('#GerminationPercentTotal').text().trim(),
                    //        color: '#094356',
                    //        data: [res[i].GerminationPercentTotal]
                    //    });

                        data.push({
                            name: $('#GerminationPercent5Year').text().trim(),
                            color: 'rgb(77,77,77)',
                            data: [res[i].GerminationPercent5Year]
                        });

                    if (data.length > 0)
                        this.createChart(i, res[i].VarietyName, "%", 1, data);
                }
                ($('#cleaningGerminationTable') as any).footable();
                this.showSpinner(false);

                this.delay(1).then(() => {
                    this.showContent(true);
                });
            });
        } else {
            this.showCleaningGermination(false);
        }
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private createChart(id: number, title: string, unit: string, decimals: number, data: Highcharts.IndividualSeriesOptions[]): void {
        let idAttribute = `chart${id}`;

        this.benchmarkCharts.push(idAttribute);

        //console.log(this.benchmarkCharts())

        let myChart = Highcharts.chart(idAttribute, {
            chart: {
                type: 'column'
            },
            //colors: ['rgb(0,71,94)', 'rgb(69,188,227)', 'rgb(0,167,222)', 'rgb(28,78,94)', 'rgb(0,129,171)'],
            lang: {
                decimalPoint: 'hej'
            },
            tooltip: {
                formatter: function () {
                    return '<span style="color:' + this.point.series.color + '">' + this.point.series.name + '</span>: <b>' + Highcharts.numberFormat(this.y, decimals, ',', '.') + '</b>';
                }
            },
            credits: {
                enabled: false
            },
            title: {
                text: title
            },
            xAxis: {
                categories: ['']
            },
            yAxis: {
                title: {
                    text: unit
                }
            },
            series: data
        });
    }

    private getUrlParameters(): UrlParameters {
        let urlParameters = new UrlParameters();

        let selectedVarietyIds = new Array();

        for (var variety of this.selectedVarieties()) {
            if (variety.Selected) {
                urlParameters.cultivationMethod = variety.CultivationMethod;
                selectedVarietyIds.push(variety.VarietyId);
            }
        }

        let parameter = this.selectedParameter() as any;

        urlParameters.excludeBornholm = !this.postcodeSelected() ? false : this.excludeBornholm();
        urlParameters.postCodeBegin = Number(this.postcodeBegin());
        urlParameters.postCodeEnd = Number(this.postcodeEnd());
        urlParameters.year = parameter.Year;
        urlParameters.varietyIds = selectedVarietyIds.join(",");

        return urlParameters;
    }
}